import midString from '@/utils/mid-string'

export default {
  getCardTarget (card) {
    return card?.description || (card?.tags?.length > 0 ? card.tags.join(', ') : 'card')
  },

  newSortkeyLastInList (workflow) {
    let lastCardSortkey = ''
    const lastCard = this.getLastCardOnSortKey(workflow)

    if (lastCard) {
      lastCardSortkey = lastCard.sortkey
    }

    return this.generateNewSortKey(lastCardSortkey)
  },

  newSortkeyNextInList (workflow, sortkey) {
    const cards = this.getCardsFromSortkey(workflow, sortkey, 2)
    const afterKey = cards[0]?.sortkey
    const beforeKey = cards[1]?.sortkey
    return this.generateNewSortKey(afterKey, beforeKey)
  },

  getLastCardOnSortKey (workflow) {
    let lastCard
    const sortedCards = getSortedCards(workflow)

    if (sortedCards?.length > 0) {
      lastCard = sortedCards[sortedCards.length - 1]
    }

    return lastCard
  },

  getCardsFromSortkey (workflow, sortkey, numberOfCards) {
    let counter = 0
    const res = []
    const sortedCards = getSortedCards(workflow)
    if (sortedCards?.length > 0) {
      const index = sortedCards.findIndex((card) => card.sortkey === sortkey)
      if (index >= 0) {
        for (let i = index; i < sortedCards.length; i++) {
          res.push(sortedCards[i])
          counter++
          if (counter === numberOfCards) {
            break
          }
        }
      }
    }

    return res
  },

  generateNewSortKey (after = '', before = '') {
    return midString(after, before)
  },

  sortByReleaseAndSortKey (cards) {
    cards.sort((a, b) => {
      if (a.releaseNo !== b.releaseNo) {
        if (a.releaseNo === undefined || a.releaseNo === null) return 1 // Place 'a' after 'b' if 'a.releaseNo' is undefined
        if (b.releaseNo === undefined || b.releaseNo === null) return -1 // Place 'b' after 'a' if 'b.releaseNo' is undefined
        return a.releaseNo - b.releaseNo // Ascending order by releaseNo
      }
      return a.sortkey.localeCompare(b.sortkey)
    })
  },

  moveCard (ev, cards, cardsByTypes, cardTypeId) {
    const { item, newIndex } = ev
    const { cardId } = item.dataset
    const card = cards.find(({ id }) => id === cardId)

    const prevCard = cardsByTypes[cardTypeId][newIndex - 1]
    const nextCard = cardsByTypes[cardTypeId][newIndex + 1]
    const prevSortKey = prevCard &&
    ((nextCard && prevCard.releaseNo === nextCard.releaseNo) || (ev.newIndex > ev.oldIndex))
      ? prevCard.sortkey
      : ''
    const nextSortKey = nextCard &&
    ((prevCard && prevCard.releaseNo === nextCard.releaseNo) || (ev.newIndex < ev.oldIndex))
      ? nextCard.sortkey
      : ''
    const sortkey = midString(prevSortKey, nextSortKey)

    const releaseNo = (ev.newIndex > ev.oldIndex ? prevCard : nextCard)?.releaseNo || null

    return { ...card, sortkey, releaseNo, cardTypeId }
  }
}

function getAllCards (workflow) {
  if (!workflow.domainEvents) {
    return
  }

  let cards = []

  for (const event of workflow.domainEvents) {
    if (event.cards) {
      cards = cards.concat(event.cards)
    }
  }

  return cards
}

function getSortedCards (workflow) {
  let sortedCards = []
  const allCards = getAllCards(workflow)

  if (allCards?.length > 0) {
    sortedCards = allCards.sort((a, b) => a.sortkey < b.sortkey ? -1 : 1)
  }

  return sortedCards
}
